import { HttpClient } from '@angular/common/http';
import { Directive, ElementRef, Input, OnChanges, OnDestroy, SimpleChanges, inject } from '@angular/core';
import { Subscription } from 'rxjs';

@Directive({
  selector: 'img[httpSrc]',
  standalone: true,
})
export class HttpSrcDirective implements OnChanges, OnDestroy {
  @Input() httpSrc: string | null | undefined;

  private readonly http = inject(HttpClient);
  private readonly elementRef = inject<ElementRef<HTMLImageElement>>(ElementRef);
  private request?: Subscription;
  private objectUrl: string | null = null;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['httpSrc']) this.load(this.httpSrc);
  }

  ngOnDestroy(): void {
    this.request?.unsubscribe();
    this.revokeObjectUrl();
  }

  private load(url: string | null | undefined): void {
    this.request?.unsubscribe();
    this.request = undefined;
    this.revokeObjectUrl();

    const image = this.elementRef.nativeElement;
    image.removeAttribute('src');
    if (!url) return;

    if (url.startsWith('data:') || url.startsWith('blob:')) {
      image.src = url;
      return;
    }

    this.request = this.http.get(url, {
      responseType: 'blob',
      headers: { Accept: 'image/webp,image/*,*/*;q=0.8' },
    }).subscribe({
      next: blob => {
        this.objectUrl = URL.createObjectURL(blob);
        image.src = this.objectUrl;
      },
      error: () => image.removeAttribute('src'),
    });
  }

  private revokeObjectUrl(): void {
    if (!this.objectUrl) return;
    URL.revokeObjectURL(this.objectUrl);
    this.objectUrl = null;
  }
}
